import { render, staticRenderFns } from "./recycleMsgDialog.vue?vue&type=template&id=6e7df2b8&scoped=true"
import script from "./recycleMsgDialog.vue?vue&type=script&lang=js"
export * from "./recycleMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./recycleMsgDialog.vue?vue&type=style&index=0&id=6e7df2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7df2b8",
  null
  
)

export default component.exports